import {
  Semanticpmpmvt7fldq2 as Semantic,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  EmphasizedSemantic_getInstancev1hnk3pae9tz as EmphasizedSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  MessageSemantic26vy91vxbjwf0 as MessageSemantic,
} from './sections.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import {
  Constant5dc3leeorpdb as Constant,
  ForceConstant11m1vt5jr2l8f as ForceConstant,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  WarningButtonSemantice48d7oqt0xse as WarningButtonSemantic,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from './buttons.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FormHeaderClass;
function FormHeader() {
  if (FormHeaderClass === VOID) {
    class $ extends Semantic() {
      static hjr() {
        FormHeader_instance = null;
        var $this = this.dd1('frmhdr');
        FormHeader_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = Companion_getInstance().bcz(5526612);
        var tmp1_foreground = Companion_getInstance().taz_1;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'FormHeader';
      }
      hashCode() {
        return 1416456739;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FormHeader()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FormHeader');
    FormHeaderClass = $;
  }
  return FormHeaderClass;
}
var FormHeader_instance;
function FormHeader_getInstance() {
  if (FormHeader_instance === VOID)
    FormHeader().hjr();
  return FormHeader_instance;
}
function FormMessage$default$lambda($this$to, it) {
  return $this$to.jd1(it.fb1(LightSection_getInstance()).gb1_1, VOID, VOID, VOID, VOID, get_rem(1), Edges().cd0(get_rem(1)));
}
function FormMessage$default$lambda_0($this$to, it) {
  var tmp0_background = AppColors_getInstance().efz_1.aga_1;
  var tmp1_foreground = Companion_getInstance().taz_1;
  var tmp2_gap = get_rem_0(0.75);
  var tmp3_padding = Edges().cd0(get_rem_0(0.75));
  var tmp4_cornerRadii = new (Constant())(get_rem(1));
  var tmp5_outlineWidth = get_px(0);
  return $this$to.jd1(it, VOID, VOID, VOID, tmp4_cornerRadii, tmp2_gap, tmp3_padding, tmp1_foreground, VOID, VOID, tmp5_outlineWidth, VOID, tmp0_background);
}
var FormMessageClass;
function FormMessage() {
  if (FormMessageClass === VOID) {
    class $ extends Semantic() {
      static jjr() {
        FormMessage_instance = null;
        var $this = this.dd1('frmmsg');
        FormMessage_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = get_px(1);
        var tmp_0 = CardSemantic_getInstance();
        var tmp_1 = to(tmp_0, FormMessage$default$lambda);
        var tmp_2 = EmphasizedSemantic_getInstance();
        return this.md1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_1, to(tmp_2, FormMessage$default$lambda_0)])).bb1_1;
      }
      toString() {
        return 'FormMessage';
      }
      hashCode() {
        return 1120103217;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FormMessage()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FormMessage');
    FormMessageClass = $;
  }
  return FormMessageClass;
}
var FormMessage_instance;
function FormMessage_getInstance() {
  if (FormMessage_instance === VOID)
    FormMessage().jjr();
  return FormMessage_instance;
}
var NotReadyButtonClass;
function NotReadyButton() {
  if (NotReadyButtonClass === VOID) {
    class $ extends Semantic() {
      static ljr() {
        NotReadyButton_instance = null;
        var $this = this.dd1('ntrdybtn');
        NotReadyButton_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_$receiver = theme.fb1(ButtonSemantic_getInstance()).gb1_1;
        var tmp1_background = AppColors_getInstance().ifz_1;
        var tmp2_foreground = Companion_getInstance().taz_1;
        return this.jd1(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, VOID, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'NotReadyButton';
      }
      hashCode() {
        return 1177942676;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotReadyButton()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NotReadyButton');
    NotReadyButtonClass = $;
  }
  return NotReadyButtonClass;
}
var NotReadyButton_instance;
function NotReadyButton_getInstance() {
  if (NotReadyButton_instance === VOID)
    NotReadyButton().ljr();
  return NotReadyButton_instance;
}
var ReportIncidentButtonClass;
function ReportIncidentButton() {
  if (ReportIncidentButtonClass === VOID) {
    class $ extends Semantic() {
      static njr() {
        ReportIncidentButton_instance = null;
        var $this = this.dd1('rptinc');
        ReportIncidentButton_instance = $this;
        return $this;
      }
      ed1(theme) {
        return theme.fb1(NotReadyButton_getInstance());
      }
      toString() {
        return 'ReportIncidentButton';
      }
      hashCode() {
        return -2058476502;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ReportIncidentButton()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ReportIncidentButton');
    ReportIncidentButtonClass = $;
  }
  return ReportIncidentButtonClass;
}
var ReportIncidentButton_instance;
function ReportIncidentButton_getInstance() {
  if (ReportIncidentButton_instance === VOID)
    ReportIncidentButton().njr();
  return ReportIncidentButton_instance;
}
var IssueButtonClass;
function IssueButton() {
  if (IssueButtonClass === VOID) {
    class $ extends Semantic() {
      static pjr() {
        IssueButton_instance = null;
        var $this = this.dd1('isubtn');
        IssueButton_instance = $this;
        return $this;
      }
      ed1(theme) {
        return WarningButtonSemantic().hd1(theme);
      }
      toString() {
        return 'IssueButton';
      }
      hashCode() {
        return 1608382969;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IssueButton()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'IssueButton');
    IssueButtonClass = $;
  }
  return IssueButtonClass;
}
var IssueButton_instance;
function IssueButton_getInstance() {
  if (IssueButton_instance === VOID)
    IssueButton().pjr();
  return IssueButton_instance;
}
function DisputeButton$default$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().jfz_1.zg9_1, get_px(2), VOID, Companion_getInstance().taz_1);
}
function DisputeButton$default$lambda_0($this$to, it) {
  var tmp0_background = Companion_getInstance().taz_1;
  var tmp1_outline = AppColors_getInstance().hfz_1.bga_1;
  var tmp2_outlineWidth = get_px(1);
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
}
var DisputeButtonClass;
function DisputeButton() {
  if (DisputeButtonClass === VOID) {
    class $ extends Semantic() {
      static rjr() {
        DisputeButton_instance = null;
        var $this = this.dd1('dsptbtn');
        DisputeButton_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = theme.fb1(DangerButtonSemantic_getInstance()).gb1_1;
        var tmp_0 = UnselectedSemantic_getInstance();
        var tmp_1 = to(tmp_0, DisputeButton$default$lambda);
        var tmp_2 = SelectedSemantic_getInstance();
        return this.jd1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_1, to(tmp_2, DisputeButton$default$lambda_0)]));
      }
      toString() {
        return 'DisputeButton';
      }
      hashCode() {
        return 267699748;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DisputeButton()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DisputeButton');
    DisputeButtonClass = $;
  }
  return DisputeButtonClass;
}
var DisputeButton_instance;
function DisputeButton_getInstance() {
  if (DisputeButton_instance === VOID)
    DisputeButton().rjr();
  return DisputeButton_instance;
}
function ConcernCard$default$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance().taz_1);
}
function ConcernCard$default$lambda_0($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance().taz_1);
}
function ConcernCard$default$lambda_1($this$to, it) {
  return it.cb1_1;
}
function ConcernCard$default$lambda_2($this$to, it) {
  return $this$to.gd1(it, VOID, it.gb0_1.fd1(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
}
var ConcernCardClass;
function ConcernCard() {
  if (ConcernCardClass === VOID) {
    class $ extends Semantic() {
      static tjr() {
        ConcernCard_instance = null;
        var $this = this.dd1('cncrn');
        ConcernCard_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = theme.fb1(LightSection_getInstance()).gb1_1;
        var tmp_0 = MessageSemantic().sgt(true);
        var tmp_1 = to(tmp_0, ConcernCard$default$lambda);
        var tmp_2 = MessageSemantic().sgt(false);
        var tmp_3 = to(tmp_2, ConcernCard$default$lambda_0);
        var tmp_4 = DisabledSemantic_getInstance();
        var tmp_5 = to(tmp_4, ConcernCard$default$lambda_1);
        var tmp_6 = EmphasizedSemantic_getInstance();
        return this.jd1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_1, tmp_3, tmp_5, to(tmp_6, ConcernCard$default$lambda_2)]));
      }
      toString() {
        return 'ConcernCard';
      }
      hashCode() {
        return 799022686;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ConcernCard()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ConcernCard');
    ConcernCardClass = $;
  }
  return ConcernCardClass;
}
var ConcernCard_instance;
function ConcernCard_getInstance() {
  if (ConcernCard_instance === VOID)
    ConcernCard().tjr();
  return ConcernCard_instance;
}
function LargeSelectionCards$default$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance().taz_1);
}
function LargeSelectionCards$default$lambda_0($this$to, it) {
  var tmp0_outline = AppColors_getInstance().hfz_1.aga_1;
  var tmp1_background = Companion_getInstance().taz_1;
  var tmp2_outlineWidth = get_px(1);
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_outline, tmp2_outlineWidth, VOID, tmp1_background);
}
function LargeSelectionCards$default$lambda_1($this$to, it) {
  var tmp0_outline = AppColors_getInstance().jfz_1.zg9_1;
  var tmp1_background = Companion_getInstance().taz_1;
  var tmp2_outlineWidth = get_px(2);
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_outline, tmp2_outlineWidth, VOID, tmp1_background);
}
var LargeSelectionCardsClass;
function LargeSelectionCards() {
  if (LargeSelectionCardsClass === VOID) {
    class $ extends Semantic() {
      static vjr() {
        LargeSelectionCards_instance = null;
        var $this = this.dd1('lrgsel');
        LargeSelectionCards_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = new (Constant())(get_rem(1));
        var tmp_0 = get_AppDimensions().zg1_1;
        var tmp_1 = CardSemantic_getInstance();
        var tmp_2 = to(tmp_1, LargeSelectionCards$default$lambda);
        var tmp_3 = UnselectedSemantic_getInstance();
        var tmp_4 = to(tmp_3, LargeSelectionCards$default$lambda_0);
        var tmp_5 = SelectedSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_2, tmp_4, to(tmp_5, LargeSelectionCards$default$lambda_1)]));
      }
      toString() {
        return 'LargeSelectionCards';
      }
      hashCode() {
        return 1526724576;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LargeSelectionCards()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LargeSelectionCards');
    LargeSelectionCardsClass = $;
  }
  return LargeSelectionCardsClass;
}
var LargeSelectionCards_instance;
function LargeSelectionCards_getInstance() {
  if (LargeSelectionCards_instance === VOID)
    LargeSelectionCards().vjr();
  return LargeSelectionCards_instance;
}
var ModernDialogClass;
function ModernDialog() {
  if (ModernDialogClass === VOID) {
    class $ extends Semantic() {
      static xjr() {
        ModernDialog_instance = null;
        var $this = this.dd1('mdndlg');
        ModernDialog_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = AppColors_getInstance().hfz_1.cga_1;
        var tmp1_elevation = get_dp(1);
        var tmp2_gap = get_AppDimensions().zg1_1;
        var tmp3_outlineWidth = get_dp(0);
        var tmp4_cornerRadii = new (ForceConstant())(get_rem(1));
        return this.jd1(theme, false, VOID, tmp1_elevation, tmp4_cornerRadii, tmp2_gap, VOID, VOID, VOID, VOID, tmp3_outlineWidth, VOID, tmp0_background);
      }
      toString() {
        return 'ModernDialog';
      }
      hashCode() {
        return -599732615;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ModernDialog()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ModernDialog');
    ModernDialogClass = $;
  }
  return ModernDialogClass;
}
var ModernDialog_instance;
function ModernDialog_getInstance() {
  if (ModernDialog_instance === VOID)
    ModernDialog().xjr();
  return ModernDialog_instance;
}
//region block: exports
export {
  ConcernCard_getInstance as ConcernCard_getInstance1gv23vco4jz4i,
  DisputeButton_getInstance as DisputeButton_getInstance2kmp95ogq1c02,
  FormHeader_getInstance as FormHeader_getInstance1rs49tmvkejrt,
  FormMessage_getInstance as FormMessage_getInstance34lpbvoeaecrx,
  IssueButton_getInstance as IssueButton_getInstance2eudvtxrfqyy3,
  LargeSelectionCards_getInstance as LargeSelectionCards_getInstance3chs6is67e0a5,
  ModernDialog_getInstance as ModernDialog_getInstance34rv0w4qmp4oc,
  NotReadyButton_getInstance as NotReadyButton_getInstance12ctldyuk6wtt,
  ReportIncidentButton_getInstance as ReportIncidentButton_getInstance34farqsakvpxm,
};
//endregion

//# sourceMappingURL=formThemes.mjs.map
